<ng-container [formGroup]="form">
  <div class="d-flex flex-column gap-2 px-3 pt-3" *ngIf="showHeader">
    <table class="table">
      <tbody>
        <tr>
          <td i18n>To:</td>
          <td class="w-100">
            <div class="d-flex align-items-center gap-2">
              <mat-form-field2 class="mat-block" [showLabel]="false">
                <input
                  matInput
                  required
                  i18n-placeholder
                  placeholder="To"
                  type="text"
                  [value]="inquiry.guestDetails?.name"
                  disabled
                />
              </mat-form-field2>
              <div class="d-flex align-items-center gap-2">
                <a (click)="hasCC = !hasCC" [class.active]="hasCC">CC</a>
                <a (click)="hasBCC = !hasBCC" [class.active]="hasBCC">BCC</a>
                <a
                  class="text-secondary text-lg position-relative"
                  matTooltip="Close"
                  (click)="onClose()"
                  style="top: -1.25rem; right: -0.25rem"
                >
                  <i class="far fa-times"></i>
                </a>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="hasCC">
          <td>CC:</td>
          <td>
            <app-form-tags2
              [items]="[]"
              [formControl]="form.get('cc')"
              [showLabel]="false"
              [createTagFn]="addNewCC"
              i18n-placeholder
              placeholder="Enter email"
            ></app-form-tags2>
          </td>
        </tr>
        <tr *ngIf="hasBCC">
          <td>BCC:</td>
          <td>
            <app-select-search
              [items]="users$ | async"
              [ctrl]="form.get('bcc')"
              [inline]="true"
              bindLabel="name"
              bindValue="primaryEmail"
              i18n-placeholder
              placeholder="Nothing Selected"
              class="mat-block"
            ></app-select-search>
          </td>
        </tr>
        <tr *ngIf="guest">
          <td i18n>Inquiry:</td>
          <td>
            <app-select-search
              [items]="inquiries$ | async"
              [ctrl]="inquiryCtrl"
              (search)="inquirySearch.next($event)"
              [multiple]="false"
              [inline]="true"
              bindLabel="name"
              bindValue="id"
              i18n-placeholder
              placeholder="Nothing Selected"
              class="mat-block"
            ></app-select-search>
          </td>
        </tr>
        <tr>
          <td i18n>Subject:</td>
          <td>
            <mat-form-field2 class="mat-block" [showLabel]="false">
              <input matInput required i18n-placeholder placeholder="To" type="text" formControlName="subject" />
            </mat-form-field2>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- editor -->
  <div class="comment-composer flex-fill px-3 pt-3">
    <ng-container *ngIf="showEditor">
      <div class="additional-actions position-absolute">
        <a
          class="btn btn-secondary-light2"
          i18n-matTooltip
          matTooltip="Expand the text editor."
          matTooltipPosition="above"
          *ngIf="!isPopup && !messagingChannel?.isUsingWhatsappTemplate"
          (click)="onPopup()"
          ><i class="cs-icon cs-icon-expand"></i
        ></a>
        <a
          class="btn btn-secondary-light2 text-xxl"
          i18n-matTooltip
          matTooltip="Close"
          matTooltipPosition="above"
          (click)="onClose()"
          *ngIf="!showHeader"
        >
          <i class="far fa-times"></i>
        </a>
      </div>
      <app-tiny-mce-editor
        #tinyMceEditor
        additionalToolbar="| datadic | subject"
        [options]="tinyMceOptions"
        [minHeight]="minEditorHeight"
        [maxHeight]="maxEditorHeight"
        (setup)="onEditorSetup($event)"
        [ctrl]="messageEditorCtrl"
        [disabled]="messagingChannel?.isUsingWhatsappTemplate"
      ></app-tiny-mce-editor>
    </ng-container>
    <div class="mt-2 d-flex flex-wrap gap-2" *ngIf="attachments.length">
      <span
        class="badge badge-light badge-pill d-inline-flex align-items-center gap-2"
        *ngFor="let attachment of attachments"
      >
        <i class="cs-icon cs-icon-paperclip text-muted"></i>
        <span class="text-break">{{ attachment.name }}</span>
        <button
          type="button"
          class="btn btn-link text-danger p-0 h-auto"
          (click)="removeAttachment(attachment)"
          i18n-matTooltip
          matTooltip="Remove attachment"
        >
          <i class="far fa-times"></i>
        </button>
      </span>
    </div>
    <div
      *ngIf="isAIGenerating"
      class="position-absolute d-flex flex-column align-items-center justify-content-center bg-white text-center"
      style="top: 0; left: 0; right: 0; bottom: 0; opacity: 0.95; z-index: 2"
    >
      <app-loading-section class="ai-generating" style="padding: 25px 0"></app-loading-section>
      <div>
        <ng-container i18n>Our AI is putting on its thinking cap, pondering your question. </ng-container><br />
        <ng-container i18n>Hang in there!</ng-container>
      </div>
    </div>
  </div>

  <!-- buttons -->
  <div class="d-flex align-items-center p-3" style="overflow-x: auto; overflow-y: hidden">
    <app-messaging-channel-switcher
      [form]="form"
      [inquiry]="inquiry"
      (featuresChange)="onEditorFeaturesChange($event)"
      #msgChannel
    ></app-messaging-channel-switcher>
    <app-messaging-channel-contacts
      [inquiry]="inquiry"
      [channel]="messagingChannel?.selectedChannel"
    ></app-messaging-channel-contacts>
    <div class="flex-fill"></div>
    <ul class="list-reset d-flex align-items-center gap-3">
      <ng-container>
        <li *ngIf="(enableQuote | call : inquiry) && availableEditorFeatures.includes('quote')">
          <mat-checkbox
            i18n-matTooltip
            matTooltip="Insert quote into email"
            matTooltipPosition="above"
            formControlName="addCost"
            class="mt-primary addcost"
          >
            <ng-container i18n>Add Quote</ng-container>
          </mat-checkbox>
        </li>
        <li *ngIf="availableEditorFeatures.includes('template')">
          <app-select-search
            [items]="templates$ | async"
            (valueChange)="onTemplateChange($event)"
            [hasBlank]="true"
            [multiple]="false"
            bindLabel="name"
            i18n-placeholder
            placeholder="Select Template"
            style="width: 12rem"
          ></app-select-search>
        </li>
        <li *ngIf="availableEditorFeatures.includes('attachment')">
          <a
            (click)="onAttachment()"
            [matTooltip]="getAttachmentTooltip()"
            matTooltipPosition="above"
            class="btn btn-secondary-light text-xl"
          >
            <i class="cs-icon cs-icon-paperclip"></i>
          </a>
        </li>
        <ng-container *ngIf="availableEditorFeatures.includes('ai')">
          <li *ngIf="aiMessageSummary">
            <a
              href="javascript:void(0)"
              [matTooltip]="'AI Message Summary:\n ' + aiMessageSummary"
              class="btn btn-secondary-light text-xl"
            >
              <i class="fas fa-info-circle"></i>
            </a>
          </li>
          <li>
            <a
              (click)="onAiResponder()"
              [matTooltip]="
                isAISubscriptionValid
                  ? 'Generate a reply for the above message.'
                  : 'Go to Appstore to subscribe for this'
              "
              [style.filter]="isAISubscriptionValid ? 'none' : 'grayscale(1)'"
              matTooltipPosition="above"
              class="btn btn-secondary-primary text-xl"
            >
              <i class="cs-icon cs-icon-ai"></i>
            </a>
          </li>
        </ng-container>
      </ng-container>
      <li
        matTooltip="Create an Inquiry first to be able to message this guest"
        i18n-matTooltip
        [matTooltipDisabled]="isSenable"
      >
        <app-button
          (click)="onSend(form)"
          icon="cs-icon cs-icon-send"
          [class]="'success' | buttonClass"
          [disabled]="(isAddingMessage$ | async) || isAIGenerating || !isSenable"
          [loading]="isAddingMessage$ | async"
        >
          <ng-container i18n>Send</ng-container>
        </app-button>
      </li>
    </ul>
  </div>
  <app-drag-drop-upload-overlay
    class="drag-drop-layer"
    [enabled]="isDragDropEnabled"
    [options]="dragDropUploadOptions"
    [showUploadBox]="false"
    [allowDocumentDrop]="true"
    (uploaded)="onDragDropUploadComplete($event)"
  ></app-drag-drop-upload-overlay>
</ng-container>
